import { create } from 'zustand';

export type MessageLevel = 'success' | 'info' | 'warning' | 'error';

export interface ConsoleMessage {
  id: string;
  level: MessageLevel;
  text: string;
  timestamp: Date;
}

interface ConsoleState {
  messages: ConsoleMessage[];
  addMessage: (level: MessageLevel, text: string) => void;
  clearMessages: () => void;
}

function createMessage(level: MessageLevel, text: string): ConsoleMessage {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    level,
    text,
    timestamp: new Date(),
  };
}

export const useConsoleStore = create<ConsoleState>((set) => ({
  messages: [
    createMessage('success', 'IDE Ready! Select your board and start coding.'),
    createMessage('info', 'Ready to connect'),
    createMessage('info', 'System initialized'),
  ],
  addMessage: (level, text) =>
    set((state) => ({ messages: [...state.messages, createMessage(level, text)] })),
  clearMessages: () => set({ messages: [] }),
}));
